<template>
    <v-container fill-height fluid grid-list-xl class="pl-3 pt-3">
        <v-layout wrap>
            <v-flex xs12 v-if="request && request.id">
                <router-link
                    :to="{ name: 'HelpDeskRequests' }"
                    class="font-weight-bold text--primary"
                    style="text-decoration: none;"
                >
                    <span style="color:green">All Support Requests</span>
                </router-link>

                <span>/{{ request.subject }}</span>
            </v-flex>

            <v-flex xs9 class="pb-2">
                <v-card
                    style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                >
                    <div v-if="loading" class="px-3 mt-2 py-2">
                        <v-progress-linear
                            :indeterminate="true"
                            color="success"
                        ></v-progress-linear>
                    </div>
                    <v-layout row justify-space-between>
                        <v-layout column class="ma-1 px-3">
                            <v-card-text
                                class="mb-0 pb-0 pt-2 pl-2"
                                v-if="request && request.id"
                            >
                                <div
                                    class="headline pt-2 mt-1 font-weight-bold mb-0 ml-0"
                                >
                                    <span>{{ request.subject }}</span>
                                </div>

                                <v-divider class="pt-1 mt-3"></v-divider>

                                <div class="my-2 body-1 font-weight-light">
                                    Requested By:
                                    <span class="font-weight-medium">{{
                                        request.name
                                    }}</span>
                                    On:
                                    <span class="font-weight-medium">{{
                                        request.createdAt | time
                                    }}</span>
                                    Email :
                                    <span class="font-weight-medium">{{
                                        request.requesterEmail
                                    }}</span>
                                    Site:
                                    <span class="font-weight-medium">{{
                                        request.siteName
                                    }}</span>
                                    Create via:
                                    <span class="font-weight-medium">{{
                                        request.source
                                    }}</span>
                                </div>
                                <v-divider class="pt-1 mt-3"></v-divider>
                                <!--                   <div
                                    class="ml-0 mt-4 pl-3 my-3"
                                    v-html="request.description"
                                ></div> -->
                                <v-layout
                                    row
                                    justify-end
                                    class="mb-2 mt-2"
                                    v-if="request.description"
                                >
                                    <v-flex xs11>
                                        <v-card
                                            style="border: 2px solid rgb(243, 241, 249); bposition: relative; padding-top: 40px;"
                                        >
                                            <div class="card-header">
                                                <div class="ml-3">
                                                    Description
                                                </div>
                                            </div>

                                            <div
                                                class="ml-0 mt-4 pl-3 my-3"
                                                v-html="request.description"
                                            ></div>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                                <v-layout
                                    row
                                    justify-end
                                    class="mb-2 mt-2"
                                    v-for="conversation in conversationList"
                                >
                                    <v-flex xs11>
                                        <v-card
                                            style="border: 2px solid rgb(255, 229, 229); bposition: relative; padding-top: 40px;"
                                        >
                                            <div
                                                class="card-header-conversation"
                                            >
                                                <div class="ml-3">
                                                    {{
                                                        conversation.sender.name
                                                    }}
                                                    -
                                                    {{
                                                        conversation.time
                                                            .display_value
                                                    }}
                                                    <v-icon
                                                        v-if="
                                                            conversation.has_attachments
                                                        "
                                                        >mdi-attachment</v-icon
                                                    >
                                                </div>
                                            </div>

                                            <b
                                                class="ml-0 mt-4 pl-3 my-3"
                                                v-html="conversation.subject"
                                            ></b>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-layout>
                    </v-layout>
                    <v-spacer></v-spacer>
                </v-card>
            </v-flex>

            <v-flex xs3>
                <v-card
                    class="pa-3"
                    style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                >
                    <div v-if="loading" class="">
                        <v-progress-linear
                            :indeterminate="true"
                            color="success"
                        ></v-progress-linear>
                    </div>
                    <div v-if="request">
                        <v-layout row class="mb-2 pt-3">
                            <v-icon
                                class="mr-2 ml-1"
                                dark
                                style="font-size: 50px;"
                                :color="getStatusIconColor()"
                                >{{ getStatusIcon() }}</v-icon
                            >
                            <div class="title pt-3">
                                {{ request.statusName }}
                            </div>
                        </v-layout>
                        <div class="mt-2 ml-0 pr-3">
                            {{ getClosedInfo() }}
                        </div>
                        <v-divider class="mt-3"></v-divider>
                        <div class="mt-4 ml-3">
                            <v-layout row class="mb-2">
                                <div class="font-weight-medium mr-2">
                                    Ticket Number:
                                </div>
                                <div v-if="isTechnician()">
                                    <a
                                        style="color: green;"
                                        :href="
                                            `https://utaw.sdpondemand.manageengine.com/app/itdesk/ui/requests/${
                                                request.manageengineID
                                            }/details`
                                        "
                                        target="_blank"
                                        >{{ "#" + request.displayID }}</a
                                    >
                                </div>
                                <div v-if="!isTechnician()">
                                    {{ "#" + request.displayID }}
                                </div>
                            </v-layout>

                            <v-layout row class="mb-2">
                                <div class="font-weight-medium mr-2">
                                    Technician:
                                </div>
                                <div>
                                    {{ getTechnician() }}
                                </div>
                            </v-layout>

                            <v-layout row class="mb-2">
                                <div class="font-weight-medium mr-2">
                                    Category:
                                </div>
                                <div>
                                    {{ request.categoryName }}
                                </div>
                            </v-layout>
                            <v-layout row class="mb-2">
                                <div class="font-weight-medium mr-2">
                                    Priority:
                                </div>

                                <div>
                                    <v-icon
                                        id="PriorityColor"
                                        small
                                        :color="getPriorityColor()"
                                        >mdi-box-shadow</v-icon
                                    >
                                    {{ getPriority() }}
                                </div>
                            </v-layout>
                        </div>
                        <v-divider class="mt-3"></v-divider>

                        <div class="subheading font-weight-light mt-3 mb-1">
                            {{ getAttachmentText() }}
                        </div>
                        <div v-for="attachment in getAttachments()">
                            <v-btn
                                v-if="!isAudioFile(attachment.name)"
                                class="mt-2 ml-1 px-3"
                                @click="loadFile(attachment)"
                            >
                                <v-icon color="blue" left dark>mdi-file</v-icon>
                                {{ truncateText(attachment.name) }}
                                <v-icon right>mdi-open-in-new</v-icon>
                            </v-btn>
                            <audio v-if="isAudioFile(attachment.name)" controls>
                                name="media" >
                                <source
                                    :src="getAudioSrc(attachment)"
                                    type="audio/mpeg"
                                />
                            </audio>
                        </div>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import {
    groupBy,
    formatPhoneNumber,
    truncate,
    pluralize,
    getDomain,
} from "../../utils/helpers.js";
import moment from "moment";

export default {
    data: () => ({
        request: null,
        conversationList: null,
        processing: false,
        loading: true,

        regID: "",

        pagination: {
            totalCount: 0,
            rowsPerPage: 5,
            page: 1,
        },

        rules: {
            required: (v) => {
                return !!v || "Required";
            },
        },
    }),
    computed: {},
    async created() {
        await this.load();
    },
    methods: {
        async load() {
            await this.loadRequest();
        },
        async loadRequest() {
            try {
                const response = await this.$http.get(
                    `api/manageengine/getRequestbyID?id=${
                        this.$route.params.id
                    }`,
                );

                // response.description = response.description
                //     ? response.description.replaceAll(
                //           "/app/itdesk/servlet/",
                //           "https://utaw.sdpondemand.manageengine.com/app/itdesk/servlet/",
                //       )
                //     : response.description;

                if (response.notFound) {
                    this.$notify({
                        text:
                            "Ticket not found – it was probably deleted or merged with another request.",
                        group: "notification",
                        type: "error",
                    });
                    setTimeout(() => {
                        this.$router.push("/settings/help-desk-requests");
                    }, "500");
                    return;
                }
                this.request = response;
                this.loading = false;

                // if (response.notificationStatus != null) {
                //     const conversationList = await this.$http.get(
                //         `api/manageengine/ConversationList?manageengineID=${
                //             response.manageengineID
                //         }`,
                //     );
                //     this.conversationList = conversationList;
                // }
            } catch (e) {
                setTimeout(() => {
                    this.$router.push("/settings/help-desk-requests");
                }, "500");
            }
        },

        isAdmin() {
            const isAdmin = this.$store.getters["authentication/isAdmin"];
            if (!isAdmin || isAdmin == "false") return false;

            return true;
        },

        isTechnician() {
            const techList = [
                "bguttman@utaw.org",
                "cklein@utaw.org",
                "jwercberger@utaw.org",
                "mdanziger@utaw.org",
                "shiya@utaw.org",
                "supervisor@utaw.org",
                "sbl@utaw.org",
                "zkatz@utaw.org",
            ];

            const userEmail = this.$store.state.authentication.user.toLowerCase();
            const isTech = techList.includes(userEmail);
            return isTech;
        },

        formatPhoneNumber(number) {
            return formatPhoneNumber(number);
        },
        getStatusIcon() {
            if (!this.request || !this.request.statusName) return;

            switch (this.request.statusName) {
                case "Closed":
                    return "mdi-check-circle";
                case "Open":
                case "Reopened":
                    return "mdi-clock";
                case "On Hold":
                    return "mdi-clock";
                case "Canceled":
                    return "mdi-cancel";
                default:
                    return "";
            }
        },
        getStatusIconColor() {
            if (!this.request || !this.request.statusName) return;

            switch (this.request.statusName) {
                case "Closed":
                    return "#2ecc71";
                case "Open":
                case "Reopened":
                    return "#f1c40f";
                case "On Hold":
                    return "#3498db";
                case "Canceled":
                    return "#e74c3c";
                default:
                    return "#bdc3c7";
            }
        },
        getClosedInfo() {
            let lastUpdatedTime = new Date(this.request.lastUpdatedTime);
            if (this.request.statusName != "Closed") {
                return `Ticket was last updated on ${lastUpdatedTime.toLocaleDateString()} at ${lastUpdatedTime.toLocaleTimeString()} `;
            }
            return `Ticket closed on ${lastUpdatedTime.toLocaleDateString()} at ${lastUpdatedTime.toLocaleTimeString()}`;
        },
        getAttachmentText() {
            const getAttachments = this.getAttachments();
            if (!getAttachments || getAttachments.length == 0) {
                return;
            }
            return (
                getAttachments.length +
                " " +
                pluralize("Attachment", getAttachments.length)
            );
        },
        getAttachments() {
            if (!this.request || !this.request.attachments) return [];
            return JSON.parse(this.request.attachments);
        },

        getTechnician() {
            if (!this.request || !this.request.technicianEmail)
                return "The ticket is still awaiting assignment";

            return (
                this.request.technicianName +
                " - " +
                this.request.technicianEmail
            );
        },
        // downloadAttachment(attachment) {
        //     window.location = attachment;
        // },
        truncateText(attachment) {
            return truncate(attachment, 30);
        },
        async loadFile(file) {
            const url =
                getDomain() +
                `/api/manageengine/GetAttachments?url=${encodeURIComponent(
                    file.content_url,
                )}`;
            const response = await fetch(url, {
                headers: {
                    authorization: `${$cookies.get("user-token")}`,
                },
            });
            const blob = await response.blob();
            const objectUrl = URL.createObjectURL(blob);
            window.open(objectUrl, "_blank");
        },
        isAudioFile(fileName) {
            const audioExtensions = [".mp3", ".wav", ".ogg", ".m4a"];
            return audioExtensions.some((ext) =>
                fileName.toLowerCase().endsWith(ext),
            );
        },

        getAudioSrc(file) {
            return `${getDomain()}/api/manageengine/GetAttachments?url=${
                file.content_url
            }&name=${file.name}`;
        },
        getPriority() {
            const priorityMap = {
                "1 High": "High",
                "3 Option 8": "High",
                "2 Normal": "Normal",
                "4 Low": "Low",
            };
            return priorityMap[this.request.priority];
        },

        getPriorityColor() {
            const priorityMap = {
                "1 High": "#e74c3c",
                "3 Option 8": "#e74c3c",
                "2 Normal": "#f39c12",
                "4 Low": "#7f8c8d",
            };
            return priorityMap[this.request.priority];
        },
    },
};
</script>
<style>
.v-expansion-panel__header {
    height: 63px;
}
.spacail-needs-link {
    color: rgb(76, 175, 80);
    display: inline-block;
    word-wrap: break-word;
    width: 100%;
}
.tip-grid.container {
    padding-left: 0px !important;
    padding-right: 0px !important;
    padding-bottom: 0px !important;
}
.tip-grid .v-card__text {
    padding-top: 4px !important;
}
.tip-grid .flex {
    padding: 0px !important;
    padding-top: 24px !important;
}
.tip-grid .v-card {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14),
        0 0 0 0 rgba(0, 0, 0, 0.12) !important;
}
.card-header {
    background: rgb(243, 241, 249);
    padding: 5px 0;
    font-weight: bold;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}
.card-header-conversation {
    background: rgb(255, 229, 229);
    padding: 5px 0;
    font-weight: bold;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}
</style>
